import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Member {
  uuid: string;
  user: {
    uuid: number;
    username: string;
    email: string;
  };
  role: string;
  status: string;
  joined_at: string;
}

interface DeleteMemberDialogProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  selectedMember: Member | null;
}

const DeleteMemberDialog: React.FC<DeleteMemberDialogProps> = ({ open, onClose, onDelete, selectedMember }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("preferences.enterprise.confirmDeleteMember")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {selectedMember
            ? t("preferences.enterprise.confirmDeleteMemberText") +
              `: ${selectedMember.user.username} (${selectedMember.user.email})`
            : t("preferences.enterprise.confirmDeleteMemberText")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("common.cancel")}</Button>
        <Button onClick={onDelete} color="error">
          {t("preferences.enterprise.delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteMemberDialog;
